import React, { useEffect, useState } from "react";

import { getControllerUncached } from "../../../../controllers/getter";
import SamedayDashboardController from "../../../../controllers/dashboard/SamedayDashboard";

import { MapSection } from "./sameday/Map";
import { MainWindow } from "../../MainWindow";
import { Dynamic } from "../../../../controllers/conductor";
import { Button } from "../../../widgets/buttons";
import { LoadingAnimation } from "../../../widgets/loading";

import "../../../../styles/pages/dashboard.css";
import { PieSection } from "./sameday/Pie";
import { BarSection } from "./sameday/Bar";
import { Tabs } from "../../../widgets/tabs";
import { MainRouter } from "../../../../routes";
import { parseDateWithTime } from "../../../../misc/date";


export default function SameDayDashboard() {

    /** @type { SamedayDashboardController } */
    const controller = getControllerUncached(SamedayDashboardController, { });
    const { notifiers, status } = controller;


    const goto = (target) => {
        MainRouter.goto(`/dashboard/${target}`);
    };

    const tabs = [
        { label: "SAMEDAY", onClick: () => goto("sameday"), isActive: true }
    ];
    
    return (<MainWindow className="dashboard-window" currentTab="dashboard">
        <div className="tabs-wrapper"><Tabs tabs={tabs} /></div>
        <Dynamic conductor={[ notifiers.loading, notifiers.error ]} child={()=>
           status.error ? <ErrorScreen controller={controller} /> : (!status.loading ? <Main controller={controller} /> : <LoadingWindow />)
        } />
    </MainWindow>);
}

/** @param {{ controller: SamedayDashboardController }} param0 */
function ErrorScreen({ controller }) {
    return <div>
        An error occured.
        <Button onClick={() => controller.refresh()}>Try Again</Button>
    </div>;
}

function LoadingWindow() {
    return (<center><LoadingAnimation /> Loading...</center>);
}

/** @param {{ controller: SamedayDashboardController }} param0 */
function Main({ controller }) {
    return <div className="dashboard">
        <Header controller={controller} />
        <Body controller={controller} />
    </div>;
}


/** @param {{ controller: SamedayDashboardController }} param0 */
function Header({ controller }) {

    const [ time, setTime ] = useState(parseDateWithTime(Date.now()));
    
    useEffect(() => {
        setInterval(() => {
            setTime(parseDateWithTime(Date.now()));
        }, 500);
    });

    return <header>
        <div className="left"><h2>Sameday Tourist Arrivals</h2></div>
        <div className="right">
            <div className="time">{time}</div>
        </div>
    </header>;
}


/** @param {{ controller: SamedayDashboardController }} param0 */
function Body({ controller }) {
    return <main>
        <MapSection controller={controller} />
        <PieSection controller={controller} />
        <BarSection controller={controller} />
    </main>
}